export class DemandPartnerRequest {
  demandPartnerId: string;
  demandPartnerName: string;
  bridgeAdUnitId: string;
  bridgeAdUnitName: string;
  siteName: string;
  user: string;
  comment: string;
  type: DemandPartnerRequestType;
}

export enum DemandPartnerRequestType {
  IO_CPM = 'IO_CPM',
  AD_UNIT = 'AD_UNIT',
  COMMENT = 'COMMENT'
}
